export default __webpack_public_path__ + "static/media/face.07641ebf.png";